export const inchesToFeet = (inches: number): { feet: number; inches: number } => ({
  feet: Math.floor(inches / 12),
  inches: inches % 12,
});

export const feetToInches = (feet: number, inches: number): number => feet * 12 + inches;
